import * as yup from "yup";
import dealSummaryValidation from "@/modules/client/loan-application/features/loan-origination/validations/deal-summary-validation";
import borrowerInfoValidation from "@/modules/client/loan-application/features/loan-origination/validations/borrower-info-validation";
import referrerValidation from "@/modules/client/loan-application/features/loan-origination/validations/referrer-validation";

const loanApplicationValidation = yup.object().shape({
  details: dealSummaryValidation,
  applicant: borrowerInfoValidation,
  coApplicants: yup.array().of(borrowerInfoValidation),
  referrer: referrerValidation,
});

export default loanApplicationValidation;

